/**
 * Product Quantity Input Handler
 * Manages quantity increase/decrease buttons and validation
 */
(function () {
  'use strict';
  
  function initQuantityInputs() {
    const quantityInputs = document.querySelectorAll('quantity-input');
    if (quantityInputs.length === 0) return;

    quantityInputs.forEach(container => {
      const input = container.querySelector('.quantity__input');
      const decreaseButton = container.querySelector('button[name="minus"]');
      const increaseButton = container.querySelector('button[name="plus"]');

      if (!input || !decreaseButton || !increaseButton) return;

      let originalInputValue = input.value;

      decreaseButton.addEventListener('click', handleDecrease, true);
      increaseButton.addEventListener('click', handleIncrease, true);
      input.addEventListener('change', validateInput);
      
      // Track external value changes via input event (replaces setInterval polling)
      // This event fires when the value is programmatically changed by other scripts
      input.addEventListener('input', function() {
        if (input.value !== originalInputValue) {
          originalInputValue = input.value;
        }
      });

      function handleDecrease(event) {
        event.stopPropagation();
        event.preventDefault();

        const min = parseInt(input.getAttribute('min') || '1', 10);
        const step = parseInt(input.getAttribute('step') || '1', 10);
        let currentValue = parseInt(input.value, 10);

        if (isNaN(currentValue)) currentValue = min;

        const newValue = Math.max(min, currentValue - step);

        input.value = newValue;
        originalInputValue = newValue;

        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);

        setTimeout(() => {
          if (input.value != newValue) {
            console.error('Value was reset by another script! From', newValue, 'to', input.value);
          }
        }, 50);
      }

      function handleIncrease(event) {
        event.stopPropagation();
        event.preventDefault();

        const min = parseInt(input.getAttribute('min') || '1', 10);
        const step = parseInt(input.getAttribute('step') || '1', 10);
        const hasMax = input.hasAttribute('max');
        const max = hasMax ? parseInt(input.getAttribute('max'), 10) : 9999;

        let currentValue = parseInt(input.value, 10);
        if (isNaN(currentValue)) currentValue = min;

        const newValue = Math.min(max, currentValue + step);

        input.value = newValue;
        originalInputValue = newValue;

        const changeEvent = new Event('change', { bubbles: true });
        input.dispatchEvent(changeEvent);

        setTimeout(() => {
          if (input.value != newValue) {
            console.error('Value was reset by another script! From', newValue, 'to', input.value);
          }
        }, 50);
      }

      function validateInput() {
        const min = parseInt(input.getAttribute('min') || '1', 10);
        const step = parseInt(input.getAttribute('step') || '1', 10);
        const hasMax = input.hasAttribute('max');
        const max = hasMax ? parseInt(input.getAttribute('max'), 10) : 9999;

        let value = parseInt(input.value, 10);
        if (isNaN(value)) value = min;

        value = Math.max(min, Math.min(max, value));

        const remainder = (value - min) % step;
        if (remainder !== 0) {
          value = min + Math.round((value - min) / step) * step;
          value = Math.min(max, value);
        }

        input.value = value;
        originalInputValue = value;

        const productForm = container.closest('product-form');
        if (!productForm) return;

        const sectionId = productForm.dataset.sectionId;
        
        // Safety check: ensure getProductJson is available (from product-variant-handler.js)
        if (typeof getProductJson !== 'function') {
          console.warn('getProductJson function not available - skipping recharge price update');
          return;
        }
        
        const productData = getProductJson(sectionId);
        const variantId = productForm.querySelector('[name="id"]')?.value;

        if (!productData || !variantId) return;

        const currentVariant = productData.variants.find(
          (v) => v.id.toString() === variantId
        );

        // Safety check: ensure updateRechargeWidgetPrices is available (from product-recharge-pricing.js)
        if (currentVariant && typeof updateRechargeWidgetPrices === 'function') {
          updateRechargeWidgetPrices(currentVariant, value);
        }
      }
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initQuantityInputs);
})();